import PropTypes from 'prop-types';

const LoginError = (props) => {
  // init
  const { linkText, onLinkClick } = props;

  return (
    <>
      <div>
        <h4 className="login-title">Something went wrong!!</h4>
        <h4 className="login-subtitle">
          We couldn&apos;t find your email address in this workspace.
          Please check with your administrator or try a different email.
        </h4>
      </div>
      <button type="button" className="link-button" onClick={onLinkClick}>{linkText}</button>
    </>
  );
};

LoginError.propTypes = {
  linkText: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func.isRequired,
};

export default LoginError;
